/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-05-06 15:02:50
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-05-06 15:22:48
 * @FilePath: \xhwebtool\src\random\index.ts
 */
/**
 * 大小写字母+数字 随机字符串长度 默认生成12位
 * @param {number} length 生成随机字符串长度
 * @return string
 */
var randomString = function (length) {
    if (length === void 0) { length = 12; }
    var lettersAndDigits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
        result += lettersAndDigits.charAt(Math.floor(Math.random() * lettersAndDigits.length));
    }
    return result;
};
/**
 * 数字 随机字符串长度 默认生成12位
 * @param {number} length 生成随机字符串长度
 * @return string
 */
var randomNumber = function (length) {
    if (length === void 0) { length = 12; }
    var lettersAndDigits = '0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
        result += lettersAndDigits.charAt(Math.floor(Math.random() * lettersAndDigits.length));
    }
    return result;
};

export { randomNumber, randomString };
